import PaymentService from "../../../api/paymentService";

export type CpaySession = {
    requiresPayment: boolean;
    orderId: string;
    paymentUrl?: string;
    fields?: Record<string, string>;
};

export const startCpayPayment = async (
    orderId: string,
    wishId: string,
    ticketCount: number,
    gift: object,
    pointsToUse?: number
) => {
    const {data}: { data: CpaySession } = await PaymentService.startSession({
        order_id: orderId,
        ticket_count: ticketCount,
        wish_id: wishId,
        points_to_use: pointsToUse,
        ...gift
    })

    if (!data.requiresPayment) {
        return data
    }

    if (!data.paymentUrl || !data.fields) {
        throw new Error("Invalid payment session response")
    }

    // Auto-post (hidden form)
    const form = document.createElement("form");
    form.method = "POST";
    form.action = data.paymentUrl;
    Object.entries(data.fields).forEach(([k, v]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = k;
        input.value = v;
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();

    return data
}
